import { z } from 'zod';

import { CatalogDefaultAccountKeySchema } from '../products/product.schemas.js';

import { CatalogItemStatusSchema } from './catalog-item-status.schema.js';
import { ServicePricingResponseSchema } from './service-pricing.schemas.js';

export const ServiceResponseSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  categoryId: z.uuid().nullable(),
  categorySlug: z.string().nullable(),
  serviceTypeId: z.uuid().nullable(),
  serviceTypeSlug: z.string().nullable(),
  isThirdParty: z.boolean(),
  usefulLifeMonths: z.number().int().nullable(),
  usefulLifeMeters: z.number().int().nullable(),
  alertMonths: z.number().int().nullable(),
  alertMeters: z.number().int().nullable(),
  code: z.string().nullable(),
  description: z.string().nullable(),
  estimatedDurationMinutes: z.number().int().nullable(),
  warrantyMonths: z.number().int().nullable(),
  warrantyMeters: z.number().int().nullable(),
  status: CatalogItemStatusSchema,
  pricing: ServicePricingResponseSchema,
  defaultRevenueAccountKey: CatalogDefaultAccountKeySchema.nullable(),
  defaultCostAccountKey: CatalogDefaultAccountKeySchema.nullable(),
  commissionRateBps: z.number().int().positive().nullable(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export type ServiceResponse = z.infer<typeof ServiceResponseSchema>;
